module.exports = __webpack_public_path__ + "static/media/emissor-r-4.cbca5ab3.png";